/* eslint-disable react-hooks/exhaustive-deps */
import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
import { useEffect, useState } from "react";
import {
	requestGetEventListAdmin,
	requestGetEventListTeacher,
} from "services/events/aboutEvents";
import { eventsSessionStorage } from "services/storage/events";
import useMainContext from "utils/context/useMainContext";

const useEventList = ({
	setToastMessage,
	isTeacherUser,
	currentTabIdx,
	dataPaginator,
	fillTitleViews,
	filters,
	tabData
}) => {
	const mainContext = useMainContext();
	const [eventList, setEventList] = useState([]);
	const [triggerRequest, setTriggerRequest] = useState(false);
	const [isLoading, setIsLoading] = useState(null);
	const [error, setError] = useState(false);
    const [toSynchronize, setToSynchronize] = useState(false);
	useEffect(() => {
		if (!triggerRequest) return;
		fillEventList();
		setTriggerRequest(false);
	}, [triggerRequest]);
	function checkIfThereIsEventTitleForToastMessage() {
		const { get, remove } =
			eventsSessionStorage.eventTitleForEventToastMessage;
		const eventTitle = get();
		if (!eventTitle) return;
		remove();
		const newToastMessage = {
			message: `Se eliminó el evento completo de ${eventTitle}`,
			hidden: false,
		};
		setToastMessage({ ...newToastMessage });
		setTimeout(() => {
			newToastMessage.hidden = true;
			setToastMessage({ ...newToastMessage });
		}, TIMEOUT_HIDDEN_TOAST_MESSAGE);
	}
	async function requestGetEventList() {
		const { currentPage } = dataPaginator;
		if (isTeacherUser) {
			const data = await requestGetEventListTeacher({
					page: currentPage,
					...filters.value,
			});
			return {
				eventList: data,
				toSynchronize: false
			};
		}
		return await requestGetEventListAdmin({
			filterType: tabData.filterTypes[currentTabIdx],
			page: currentPage,
			...filters.value
		});
	}
	function saveCurrentTabIdxInSessionStorage() {
		// Los docentes no tienen tabs
		if (!isTeacherUser)
			eventsSessionStorage.currentTabIdxEventList.set(currentTabIdx);
	}
	async function fillEventList() {
		saveCurrentTabIdxInSessionStorage();
		setIsLoading(true);
		await fillTitleViews();
		//#region Cargando nueva lista
		try {
			const data = await requestGetEventList();
			setEventList(data.eventList);
            setToSynchronize(data.toSynchronize);
		} catch (err) {
			setError(true);
			mainContext.setShowDialogUnexpectedError(true);
		}
		setIsLoading(false);
		//#endregion
		checkIfThereIsEventTitleForToastMessage();
	}
	return {
		fill: () => setTriggerRequest(true),
		value: eventList,
		error,
		isLoading,
		toSynchronize
	};
};

export default useEventList;
